export default "__VITE_ASSET__DAK4zMtT__"